import Builder from './class-builder';

class CompressionBuilder extends Builder {

  /*
  * Render path for desktop
  */
  getRenderPathDesktop() {
    return this.renderDomain + 'compression-spiral/desktop/';
  }

  /*
  * Render path for mobile
  */
  getRenderPathMobile() {
    return this.renderDomain + 'compression-spiral/mobile/';
  }

  /*
  * Create image SKU
  */
  getRenderImage() {
    return 'SH' + this.getWidthImage(this.selection_data.width) + '09' + this.getTreadProfileImage(this.selection_data.tread_profile) + this.getTreadMaterialImage(this.selection_data.tread_material) + this.getHandrailImage(this.selection_data.handrail) + this.getFinishImage(this.selection_data.finish);
  }

  /*
  * Match width SKU
  */
  getWidthImage(width) {
    switch (width) {
      case '36':
      case '50':
        return width;
      case '40':
      case '46':
        return '36';
      default:
        return '36';
    }
  }

  /*
  * Match tread profile SKU
  */
  getTreadProfileImage(tread_profile) {
    switch (tread_profile) {
      case 'S':
        return tread_profile;
      case 'D':
      case 'B':
        return 'S';
      default:
        return 'S';
    }
  }

  /*
  * Match tread material SKU
  */
  getTreadMaterialImage(tread_material) {
    switch (tread_material) {
      case 'M':
      case 'L':
        return tread_material;
      default:
        return 'M';
    }
  }

  /*
  * Match handrail SKU
  */
  getHandrailImage(handrail) {
    switch (handrail) {
      case 'A':
        return handrail;
      case 'V':
      case 'W':
        return 'A';
      default:
        return 'A';
    }
  }

  /*
  * Match finish SKU
  */
  getFinishImage(finish) {
    switch (finish) {
      case 'B':
      case 'C':
      case 'N':
        return finish;
      default:
        return 'B';
    }
  }

  /*
  * Create sku from object
  * The order of the sku matches the spreadsheet from Mary
  */
  setSku() {
    this.sku = this.selection_data.product_line + this.selection_data.width + this.selection_data.height + this.selection_data.tread_profile + this.selection_data.tread_material + this.selection_data.handrail + this.selection_data.finish;
  }

  /*
  * Create object from sku
  * The order of the sku matches the spreadsheet from Mary
  */
  getSkuObject(sku) {
    var product_line,
        width,
        height,
        tread_profile,
        tread_material,
        handrail,
        finish,
        selection_data = {};

    if (sku) {
      product_line = sku.substring(0, 2);
      width = sku.substring(2, 4);
      height = sku.substring(4, 6);
      tread_profile = sku.substring(6, 7);
      tread_material = sku.substring(7, 8);
      handrail = sku.substring(8, 9);
      finish = sku.substring(9, 10);


      selection_data = {
        'product_line' : product_line,
        'width' : width,
        'height' : height,
        'tread_profile' : tread_profile,
        'tread_material' : tread_material,
        'handrail' : handrail,
        'finish' : finish,
      }
    }

    this.selection_data = selection_data;
    return selection_data;
  }

}

export default CompressionBuilder;
